// Utils
import TEXT from "../../../utils/globalText";
import Validation from "../../../utils/validation";

// Components
import AmountToWords from "../../_utils/AmountToWords";
import Amount from "../../_utils/TransactionCommonComponents/Amount";
import {
  PaymentMethodAnimationConfiguration as AnimConfig,
  GlobalConfiguration,
} from "../../../utils/configurationProvider";
import CommonLayout from "../../_utils/CommonLayout";

const FieldForceRequestTxnTransferAmount = ({
  txnPayLoad,
  setTxnPayLoad,
  amountInWords,
  setAmountInWords,
  copyData,
  setCopyData,

  selectedValueName,

  NewAmount,

  type,

  currentAccountDetails,
  RequestAmountWords,
}) => {
  // Callbacks
  const allowedValue = (value) => {
    return Validation.allowedAmount(value);
  };
  const handleAmountChange = (input) => {
    const { name, value } = input?.target ? input.target : input;

    const trimmedValue = value?.toString()?.trim() ?? "";

    if (!trimmedValue) {
      setTxnPayLoad((prev) => ({
        ...prev,
        amount: "",
        amountWords: "",
      }));
      setAmountInWords("");
      return;
    }

    if (trimmedValue[0] === "0") return;

    const numericValue = trimmedValue.replace(/[^0-9.]/g, "");

    if (
      name === "amount" &&
      (allowedValue(numericValue) || !numericValue.length)
    ) {
      const amountNumber = parseFloat(numericValue);
      const amountWords =
        numericValue.trim() === "" ? "" : AmountToWords(amountNumber);

      const adjustedAmountWords =
        amountNumber > GlobalConfiguration.lengthCheckZero &&
        amountNumber <= GlobalConfiguration.lengthCheckOne
          ? amountWords.replace("rupees", "rupee")
          : amountWords;

      setTxnPayLoad((prev) => ({
        ...prev,
        amount: numericValue,
        amountWords: adjustedAmountWords,
      }));

      setAmountInWords(adjustedAmountWords);
    }
  };
  const isAmountExceeding =
    type === "PayFieldForceTxn" &&
    selectedValueName === "customname" &&
    Number(txnPayLoad?.amount) > Number(NewAmount);

  const formattedAmount = (value) => {
    if (value === "" || value === null || value === undefined) {
      return "";
    }
    return Number(value).toFixed(GlobalConfiguration.lengthCheckTwo);
  };
  return (
    <>
      <div
        className="w-width-full h-height-full px-padding-md Qlg:px-padding-base overflow-y-auto Qsmd:pt-padding-lg pt-padding-md"
        style={{ scrollbarWidth: "none" }}
      >
        <CommonLayout>
          <div
            className="w-width-full max-h-auto rounded-border-radius-md bg-primary-card"
            style={{ scrollbarWidth: "none" }}
          >
            <Amount
              title={TEXT?.AMOUNT}
              amount={
                type === "PayFieldForceTxn" &&
                Number(currentAccountDetails?.amount) ===
                  Number(txnPayLoad?.amount)
                  ? formattedAmount(currentAccountDetails?.amount)
                  : txnPayLoad?.amount
              }
              amountInWords={
                type === "PayFieldForceTxn" &&
                currentAccountDetails?.amount === txnPayLoad?.amount
                  ? RequestAmountWords(currentAccountDetails?.amount)
                  : amountInWords
              }
              copyData={copyData}
              onAmountChange={(val) =>
                handleAmountChange({ name: "amount", value: val })
              }
              onPasteApplied={() =>
                setCopyData({ title: "", data_type: "", value: "" })
              }
              isPreview={false}
              NewAmount={NewAmount}
              selectedRadioValue={selectedValueName}
              customAmountRequired={type === "PayFieldForceTxn" ? true : false}
              isAmountExceeding={isAmountExceeding}
            />
          </div>
        </CommonLayout>

        <div className="h-mobile-create-header w-width-full Qmd:hidden block"></div>
      </div>
    </>
  );
};

export default FieldForceRequestTxnTransferAmount;
